import React from 'react'
import PropTypes from 'prop-types'
import ScrollableAnchor from 'react-scrollable-anchor'

import { Row, Col } from 'antd'
import { TrophyOutlined } from '@ant-design/icons'
import { getRoom } from '../../utils/helpers'
import Bundle from '../bundle'

const Room = ({ id }) => {
  const room = getRoom(id)
  const reward = room.reward
  return (
    <div className="room" style={{ ...room.style }}>
      <ScrollableAnchor id={id}>
        <div className="room-header">
          <h1>{room.name}</h1>
          <div className="room-reward">
            <TrophyOutlined />
            <a href={reward.url} target="__blank">
              <span>{reward.name}</span>
            </a>
          </div>
        </div>
      </ScrollableAnchor>
      <Row gutter={[24, 24]}>
        {room.bundles.map((bundleId) => (
          <Col xs={24} xl={12} xxl={8} key={bundleId}>
            <Bundle bundleId={bundleId} style={room.bundleStyle} />
          </Col>
        ))}
      </Row>
    </div>
  )
}

Room.propTypes = {
  id: PropTypes.string,
}

export default Room
